import { gaEvent, gaViewItem } from "@/lib/ga4";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { isBooksProduct } from "src/api/booksProducts";
import { mixpanelEvent, productDetailPageScrolled, productDetailPageViewed, productDetailTimeSpent } from "@/lib/mixpanels/mixpanel";
import { throttle } from "lodash";
const useProductDetailEventTracking = (product)=>{
    const router = useRouter();
    const [scroll, setScroll] = useState(0);
    const onScroll = throttle(()=>{
        let { pageYOffset  } = window;
        setTimeout(()=>{
            let newScroll = pageYOffset;
            if (newScroll > scroll) {
                setScroll(newScroll);
            }
        }, 1000);
    }, 1000);
    useEffect(()=>{
        if (!product) return;
        gaEvent({
            action: "view_content",
            value: product.title,
            label: router.query.id,
            category: "page_view"
        });
        gaViewItem({
            id: product.id.toString(),
            name: product.title,
            price: product.price
        });
        if (isBooksProduct(product)) {
            productDetailPageViewed({
                id: product.id,
                category: product.category,
                price: product.price,
                source_id: null,
                source_type: product.provider,
                title: product.title
            });
        } else {
            productDetailPageViewed(product);
        }
        productDetailTimeSpent();
        window.addEventListener("scroll", onScroll, {
            passive: true
        });
        return ()=>{
            window.removeEventListener("scroll", onScroll);
        };
    }, [
        product
    ]);
    useEffect(()=>{
        const handleRouteChange = (url, param)=>{
            let { shallow  } = param;
            if (!product) return;
            //mixpanel
            mixpanelEvent("Product Detail Page time spent");
            productDetailPageScrolled({
                "Product ID": product.id,
                "Product Name": product.title,
                "Scroll Depth": scroll
            });
            setScroll(0);
        };
        router.events.on("routeChangeStart", handleRouteChange);
        return ()=>{
            router.events.off("routeChangeStart", handleRouteChange);
        };
    }, [
        router.events
    ]);
};
export default useProductDetailEventTracking;
